var map = {
	"./059d349d.jpg": 495,
	"./33FEE278-85ED-4C00-AF93-DA07B5436D7C.jpg": 3578,
	"./4C684DF9-E6BE-4E94-AFB9-04E6E24F3505.jpg": 9256,
	"./5903b1f7.jpg": 3592,
	"./6dc402e5.jpg": 8160,
	"./77c33f86-5ba8-47c3-829c-62e919ecc22d.jpg": 8098,
	"./86084945.jpg": 4645,
	"./9db0809e.jpg": 4780,
	"./CarminaBurana1.jpg": 1422,
	"./CarminaBurana2.jpg": 7369,
	"./CarminaBurana3.jpg": 5756,
	"./CarminaBurana4.jpg": 2071,
	"./CarminaBurana5.jpg": 906,
	"./CarminaBurana6.jpg": 8757,
	"./DSC_1495.JPG": 2888,
	"./Dido and Aeneas.jpg": 5865,
	"./Foto en concierto segunda.jpg": 7069,
	"./Foto en concierto.JPG": 6851,
	"./Foto profesional cantando.JPG": 6946,
	"./Foto profesional segunda.jpg": 7404,
	"./Foto profesional.JPG": 6316,
	"./Gloria.jpg": 2583,
	"./IMG_1531.jpg": 7309,
	"./IMG_1533.jpg": 9535,
	"./IMG_3251.JPG": 9569,
	"./IMG_4928.JPG": 9875,
	"./IMG_5041.JPG": 2070,
	"./IMG_5042.JPG": 3761,
	"./IMG_6134.JPG": 2670,
	"./IMG_6135.JPG": 9355,
	"./IMG_7884.jpeg": 6231,
	"./IMG_7945.JPG": 4849,
	"./IMG_8002.JPG": 8822,
	"./IMG_8003.JPG": 6835,
	"./IMG_8004.JPG": 4992,
	"./IMG_8013.JPG": 1236,
	"./IMG_8014.JPG": 4575,
	"./IMG_8142.JPG": 3447,
	"./IMG_8161.JPG": 7350,
	"./IMG_8163.JPG": 4052,
	"./IMG_8164.JPG": 7663,
	"./IMG_8354.JPG": 9204,
	"./IMG_8920.JPG": 95,
	"./IMG_8921.JPG": 2274,
	"./IMG_8923.JPG": 5344,
	"./IMG_8925.JPG": 7142,
	"./IMG_8926.JPG": 9601,
	"./IMG_8929.JPG": 9402,
	"./IMG_8930.JPG": 4160,
	"./IMG_8931.JPG": 2285,
	"./IMG_8934.JPG": 660,
	"./IMG_9251.JPG": 2395,
	"./IMG_9252.JPG": 3612,
	"./IMG_9253.JPG": 9849,
	"./IMG_9270.JPG": 3460,
	"./IMG_9271.JPG": 9649,
	"./IMG_9272.JPG": 406,
	"./IMG_9397.JPG": 7976,
	"./Iltrionfo.jpg": 1115,
	"./avatar.jpg": 1808,
	"./avatar2.jpg": 1624,
	"./d764573d.jpg": 5679,
	"./dbe480be.jpg": 681,
	"./e03ad039.jpg": 5216,
	"./onstage.jpg": 5096,
	"./onstage.mp4": 3581,
	"./poster1.jpg": 3707,
	"./poster2.jpg": 908,
	"./poster3.jpg": 8697,
	"./poster4.jpg": 9210,
	"./presentacion.jpg": 5138,
	"./reel1.mp4": 4255,
	"./reel2.mp4": 1400,
	"./reel3.mp4": 2765,
	"./reel4.mp4": 7534,
	"./residenze-Orfeo-1024x1024.jpg": 1597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7263;